import React, { useEffect, useState } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Pagination,
  Box,
  Typography,
  Card,
  CardContent,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

const DownloadHistory = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [search, setSearch] = useState('');

  const fetchLogs = async () => {
    const res = await axios.get(`${API_URL}/download-logs/`, {
      params: { page, search },
    });
    setLogs(res.data.results);
    setPages(res.data.pages);
  };

  useEffect(() => {
    fetchLogs();
  }, [page, search]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #000000ff, #000000ff, #000000ff)',
      }}
    >
      <Header1 />

      {/* Content */}
      <Box sx={{ flex: 1, px: { xs: 1, md: 4 }, py: 4 }}>
        <Card
          sx={{
            maxWidth: 1100,
            mx: 'auto',
            borderRadius: 4,
            backgroundColor: '#121212',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 15px 40px rgba(0,0,0,0.8)',
          }}
        >
          <CardContent>
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{ color: '#eaeaea', textAlign: 'center' }}
            >
              Download History
            </Typography>

            <Typography
              variant="body1"
              sx={{ color: '#b0b0b0', textAlign: 'center', mb: 3 }}
            >
              Track all user downloads with timestamps.
            </Typography>

            {/* Search */}
            <TextField
              placeholder="Search by name or email"
              fullWidth
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#b0b0b0' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#1e1e1e',
                  color: '#eaeaea',
                  '& fieldset': {
                    borderColor: 'rgba(255,255,255,0.15)',
                  },
                  '&:hover fieldset': {
                    borderColor: '#00c6ff',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#00c6ff',
                  },
                },
              }}
            />

            {/* Table */}
            <Box sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {['Name', 'Email', 'File Type', 'Downloaded At'].map((head) => (
                      <TableCell
                        key={head}
                        sx={{
                          color: '#00c6ff',
                          fontWeight: 'bold',
                          borderBottom: '1px solid rgba(255,255,255,0.1)',
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {logs.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ color: '#b0b0b0', py: 4 }}
                      >
                        No download history found
                      </TableCell>
                    </TableRow>
                  ) : (
                    logs.map((log) => (
                      <TableRow
                        key={log.id}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(0,198,255,0.08)',
                          },
                        }}
                      >
                        <TableCell sx={{ color: '#eaeaea' }}>
                          {log.name}
                        </TableCell>
                        <TableCell sx={{ color: '#b0b0b0' }}>
                          {log.email}
                        </TableCell>
                        <TableCell sx={{ color: '#b0b0b0', textTransform: 'uppercase' }}>
                          {log.file_type}
                        </TableCell>
                        <TableCell sx={{ color: '#b0b0b0' }}>
                          {new Date(log.downloaded_at).toLocaleString()}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>

            {/* Pagination */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Pagination
                count={pages}
                page={page}
                onChange={(e, value) => setPage(value)}
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#b0b0b0',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#00c6ff !important',
                    color: '#000',
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Footer2 />
    </Box>
  );
};

export default DownloadHistory;
